// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3DjL9","label":"Category_label__Ryufz","content":"Category_content__2v6YE","header":"Category_header__1CMJ7","location":"Category_location__38l2A"};